import React from 'react';
import { CalendarCheck, UserCheck, ArrowRight } from 'lucide-react';
import { Badge } from '../ui/badge';
import { formatDate } from '../../lib/utils';

const FEEDBACK_LABELS = {
    interested: { label: 'Intéressé', color: 'text-green-400 bg-green-500/10 border-green-500/20' },
    thinking: { label: 'En réflexion', color: 'text-amber-400 bg-amber-500/10 border-amber-500/20' },
    not_interested: { label: 'Pas intéressé', color: 'text-red-400 bg-red-500/10 border-red-500/20' },
};

export default function SellerVisitCard({ visit }) {
    const isUpcoming = visit.status === 'scheduled';
    const isCompleted = visit.status === 'completed';
    const feedback = visit.report?.visitor_feedback;
    const feedbackInfo = FEEDBACK_LABELS[feedback];

    return (
        <div className={`p-3 rounded-xl border transition-all ${
            isUpcoming ? 'bg-[#681793]/5 border-[#681793]/20' : 'bg-card border-border'
        }`} data-testid={`visit-card-${visit.id}`}>
            <div className="flex items-start justify-between gap-2">
                <div className="flex items-start gap-2.5">
                    <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${
                        isUpcoming ? 'bg-[#681793]/20 text-[#681793]' :
                        isCompleted ? 'bg-green-500/20 text-green-400' :
                        'bg-muted text-muted-foreground'
                    }`}>
                        {isUpcoming ? <CalendarCheck className="w-4 h-4" /> : <UserCheck className="w-4 h-4" />}
                    </div>
                    <div className="min-w-0">
                        <p className="text-sm font-medium text-foreground">
                            {isUpcoming ? 'Visite prévue' : 'Visite effectuée'}
                        </p>
                        <p className="text-xs text-muted-foreground mt-0.5">
                            {visit.scheduled_date && formatDate(visit.scheduled_date)}
                            {visit.scheduled_time && ` à ${visit.scheduled_time}`}
                        </p>
                        {visit.agent_name && (
                            <p className="text-xs text-muted-foreground">par {visit.agent_name}</p>
                        )}
                    </div>
                </div>
                {isUpcoming && (
                    <Badge className="bg-[#681793]/20 text-[#681793] border-[#681793]/30 text-[10px] shrink-0">A venir</Badge>
                )}
                {feedbackInfo && (
                    <Badge className={`${feedbackInfo.color} border text-[10px] shrink-0`}>{feedbackInfo.label}</Badge>
                )}
            </div>
            {visit.report?.visitor_comments && (
                <p className="text-xs text-muted-foreground mt-2 pl-[46px] italic">"{visit.report.visitor_comments}"</p>
            )}
            {visit.report?.next_steps && (
                <div className="mt-2 pl-[46px] flex items-center gap-1.5">
                    <ArrowRight className="w-3 h-3 text-[#FF914D]" />
                    <p className="text-xs text-[#FF914D]">{visit.report.next_steps}</p>
                </div>
            )}
        </div>
    );
}
